/* ELARVÉE smart anchor scrolling. Loaded after theme.js. */
(function () {
  'use strict';
  /* ---------------- Smart anchor scrolling ----------------
     Any link to a section on the current page (e.g. "#faq" or "/#ingredients")
     scrolls so the section sits centred under the sticky header. Sections taller
     than the screen line up just below the header. Arriving from another page
     with a #hash does the same once the page has loaded. */
  var Anchor = (function () {
    function headerH() {
      var h = document.querySelector('.section-header');
      return h ? h.getBoundingClientRect().height : 0;
    }
    function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
    function find(hash) {
      if (!hash || hash.length < 2) return null;
      var id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (e) { id = hash.slice(1); }
      var el = document.getElementById(id);
      return visible(el) ? el : null;
    }
    function targetY(el) {
      // Measure the section's content, not its outer padding, so the visible
      // part of the section is what gets centred.
      var r = el.getBoundingClientRect();
      var cs = window.getComputedStyle(el);
      var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
      var top = r.top + window.pageYOffset + pt;
      var height = Math.max(0, r.height - pt - pb);
      var hh = headerH();
      var room = window.innerHeight - hh;
      var gap = 20;
      var y = height + gap * 2 <= room ? top - hh - (room - height) / 2 : top - hh - Math.min(gap, pt);
      var max = document.documentElement.scrollHeight - window.innerHeight;
      return Math.round(Math.max(0, Math.min(y, max)));
    }
    var timer;
    function go(el, smooth) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: targetY(el), behavior: smooth && !reduce ? 'smooth' : 'instant' });
      // Re-check once lazy images and fonts have settled, and correct if needed.
      clearTimeout(timer);
      timer = setTimeout(function () {
        var y = targetY(el);
        if (Math.abs(window.pageYOffset - y) > 4) window.scrollTo({ top: y, behavior: 'instant' });
      }, smooth && !reduce ? 900 : 250);
    }
    function onClick(e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin || !url.hash || url.hash === '#') return;
      var el = find(url.hash);
      if (!el || el.matches('main, [tabindex="-1"]')) return; // other page, or skip link: let the browser handle it
      e.preventDefault();
      closeMenus();
      if (window.location.hash !== url.hash) history.pushState(null, '', url.pathname === window.location.pathname ? url.hash : window.location.pathname + url.hash);
      go(el, true);
    }
    function onLoad() {
      var el = find(window.location.hash);
      if (!el) return;
      go(el, false);
      window.addEventListener('load', function () { var e2 = find(window.location.hash); if (e2) go(e2, false); }, { once: true });
    }
    return { onClick: onClick, onLoad: onLoad, go: go, find: find };
  })();

  /* Close every menu, panel and dropdown (FAQ / accordion answers). */
  function closeMenus(includeAccordions) {
    var menu = document.querySelector('[data-mobile-menu]');
    if (menu) { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }
    document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var sp = document.querySelector('[data-search-panel]'); if (sp) sp.hidden = true;
    document.querySelectorAll('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (includeAccordions) {
      document.querySelectorAll('.acc-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var q = item.querySelector('.acc-item__q'); if (q) q.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.ing-row.is-open').forEach(function (row) {
        row.classList.remove('is-open');
        var t = row.querySelector('[data-ing-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
      });
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
    }
    document.body.classList.remove('no-scroll');
  }

  if ('scrollRestoration' in history && window.location.hash) history.scrollRestoration = 'manual';
  document.addEventListener('click', Anchor.onClick);
  window.addEventListener('popstate', function () { var el = Anchor.find(window.location.hash); if (el) Anchor.go(el, true); });

  /* Pages always render with dropdowns closed. Pages restored from the
     back/forward cache are reset to that same closed state. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeMenus(true); });

  document.addEventListener('DOMContentLoaded', Anchor.onLoad);
})();
